// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/airspace-structure.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/airspace-structure/airspace-structure.js';
import g1 from '../lessons/air-law/airspace-structure/flight-information-regions.js';

mount([g0, g1]);
